<template>
  <el-container v-title data-title="人脸图" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>其它功能</el-breadcrumb-item>
                <el-breadcrumb-item>人脸图</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <el-divider></el-divider>
              <el-form>
                <el-form-item>
                  <el-upload
                    ref="file-list-upload"
                    class="upload-demo"
                    drag
                    :on-change="handleOnChange"
                    :action="uploadUrl"
                    :auto-upload="false"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击选择</em></div>
                    <div class="el-upload__text">上传图片，单个小于10MB，单次小于1000MB</div>
                  </el-upload>
                  <el-button style="margin-left: 10px;" type="primary" :loading="loading" @click="uploadFiles">上传</el-button>
                </el-form-item>
              </el-form>
              <div style="min-height: 2rem; background-color: #EEE;">{{ uploadResult }}</div>
            </el-main>
          </el-container>
        </el-header>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      searchForm: {
        schoolId: ''
      },
      uploadUrl: this.GLOBAL.host + '/user/uploadFaceImage',
      fileList: [],
      loading: false,
      uploadResult: ''
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    handleOnChange (file, fileList) {
      this.fileList = fileList
    },
    uploadFiles () {
      if (this.searchForm.schoolId === '' || this.fileList.length === 0) return
      let formData = new FormData()
      formData.append('schoolId', this.searchForm.schoolId)
      this.fileList.forEach(file => {
        // formData.append('fileList', file.raw)
        // formData.append('fileList', this.downscaleImage(file.raw, 480))
        console.log(file)
        file = this.downscaleImage(file.raw, 480)
        formData.append('fileList', file)
      })
      let _this = this
      _this.loading = true
      _this.uploadResult = ''
      this.$axios.post(this.GLOBAL.host + '/user/uploadMeetingFace', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.fileList = []
            _this.$refs['file-list-upload'].clearFiles()
            // this.$message.success(res.data.message)
          } else {
            // this.$message.error(res.data.message)
          }
          _this.uploadResult = res.data.message
          _this.loading = false
        }
      })
    },
    downscaleImage (file, newWidth, imageArguments) {
      console.log('file: ')
      console.log(file)
      console.log(typeof file)
      var image, oldWidth, oldHeight, newHeight, canvas, ctx
      let imageType = file.type
      imageArguments = imageArguments || 0.92
      image = new Image()
      image.src = file.content
      console.log('file.content:')
      console.log(file.content)
      image.decode()
      oldWidth = image.width
      if (oldWidth <= newWidth) return file
      oldHeight = image.height
      newHeight = Math.floor(oldHeight / oldWidth * newWidth)
      canvas = document.createElement('canvas')
      canvas.width = newWidth
      canvas.height = newHeight
      ctx = canvas.getContext('2d')
      ctx.drawImage(image, 0, 0, newWidth, newHeight)
      let dataUrl = canvas.toDataURL(imageType, imageArguments)
      var arr = dataUrl.split(',')
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], file.name, { type: imageType })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/FaceImage.vue